import { Button } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import ContentConstants from '../../contentConstants';
import { ISurveyBuilderActionCreators } from '../../models';
import { ISurveyBuilderState } from '../../store/SurveyBuilderStore';
import { CardLayout, ClearDiv, ContentContainer, HeadlineSmall, InstructionsContainer, InstructionsText } from '../common';

export type SurveyCompleteParams = ISurveyBuilderState & ISurveyBuilderActionCreators & { Navigate: (route: string) => void };

export class SurveyComplete extends React.PureComponent<SurveyCompleteParams> {
	public render() {
		return (
			<CardLayout loading={false} title={ContentConstants.TITLE_SCHEDULING_IN_PROGRESS}>
				<ContentContainer>
					<InstructionsContainer>
						<HeadlineSmall>{ContentConstants.INSTRUCTIONALTITLE_SURVEY_SCHEDULING}</HeadlineSmall>
						<ClearDiv clearHeight='14px' />
						<InstructionsText>{ContentConstants.INSTRUCTIONALTEXT_SURVEY_SCHEDULING}</InstructionsText>
					</InstructionsContainer>
					<Button color='primary' size='lg' onClick={this.props.GoToSurveyList}>
						{ContentConstants.BUTTONS_GO_TO_SURVEY_LIST}
					</Button>
				</ContentContainer>
			</CardLayout>
		);
	}
}
